var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"buttom",staticClass:"case-block",class:{'black':_vm.color === 'black', 'model-2': _vm.styleModel === '2'},on:{"click":_vm.fn}},[(_vm.pic)?_c('img',{attrs:{"src":_vm.pic,"alt":"pic"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }